/**
 * Spec: https://docs.google.com/document/d/1zDn7RBMeJuoqcGtGRZtIM17fxAj12EYEEI5U8RVQENQ/edit#heading=h.anwrirsd22my
 */
import { track as mcTrack } from '@mc/track-event'
import { paths } from '@mc/paths'
import {
  ActionTypes,
  KeyTypes,
  saveUserData,
  getTrackedId,
} from '@mc/user-data'
import {
  getPageEventName,
  type PageEventNameType,
} from '@mc/pre-paywall-events'

export const LOCATION_CAT_EXP = 'category-exploration'

type ArrowDirection = 'left' | 'right'

type TrackingProps = {
  action: string
  location: typeof LOCATION_CAT_EXP
  class?: string
  category?: string
  link?: string
  stored_category_id?: string
}

const track = (event: PageEventNameType, props: TrackingProps) =>
  mcTrack(event, props)

// If User Clicks on a Category
export const trackCategoryClick = (slug: string, id?: string) => {
  const eventName = getPageEventName()
  let catId = ''

  if (id) {
    catId = getTrackedId({ key: KeyTypes.CATEGORY, id })
  }

  track(eventName, {
    action: slug,
    location: LOCATION_CAT_EXP,
    stored_category_id: catId,
  })

  if (window.location.pathname === paths.root) {
    saveUserData({
      key: KeyTypes.CATEGORY,
      id: catId,
      actionType: ActionTypes.BROWSING,
      eventName,
    })
  }
}

// If User Clicks on a Tile
export const trackTileClick =
  ({ className, category }: { className: string; category: string }) =>
  (link: string) => {
    const eventName = getPageEventName()
    track(eventName, {
      action: 'click',
      category,
      class: className,
      location: LOCATION_CAT_EXP,
      link,
    })
  }

// If User Clicks on left/right arrows
const trackCarouselArrowClick = ({
  arrow,
  category,
}: {
  arrow: ArrowDirection
  category: string
}) => {
  const eventName = getPageEventName()
  track(eventName, {
    action: arrow,
    category,
    location: LOCATION_CAT_EXP,
  })
}

export const trackCarouselClickPrev = (category: string) => {
  trackCarouselArrowClick({ arrow: 'left', category })
}

export const trackCarouselClickNext = (category: string) => {
  trackCarouselArrowClick({ arrow: 'right', category })
}

// If User Clicks on "See all" heading link
export const trackSeeAllClick = () => {
  const eventName = getPageEventName()
  track(eventName, {
    action: 'See All',
    location: LOCATION_CAT_EXP,
  })
}
